<template>
  <div class="app-activation-tariff-info-box">
    <slot name="txtBefore"></slot>
    <BookableDetailsWithActions
      v-if="selectedTariff"
      :details="selectedTariff.details"
      :actions="selectedTariff.actions"
      :info="selectedTariff.info"
      :content-theme="selectedTariff.tariffId"
      @click:details="showBookedTariffModal=true"
    >
      <template v-for="slot in possibleChildSlotsFor('BookedTariff')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </BookableDetailsWithActions>
    <TariffInfoModal v-if="selectedTariff" :show.sync="showBookedTariffModal" :tariff="selectedTariff">
      <template v-for="slot in possibleChildSlotsFor('TariffModal')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </TariffInfoModal>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>

import slotProxy from '@/mixins/slotProxy'
import TariffInfoModal from '../../../generic/Tariff/generic/CurrentTariff/TariffInfoModal.vue'
import BookableDetailsWithActions from '../../../generic/Tariff/generic/CurrentTariff/DetailsWithActions.vue'
import { price } from '@/mixins/price'
import { durationUnit } from '@/mixins/durationUnit'

export default {
  name: 'ShowTariffInfoBox',
  components: { TariffInfoModal, BookableDetailsWithActions },
  data () {
    return {
      showBookedTariffModal: false
    }
  },
  props: {
    tariff: {
      type: Object,
      default: null
    }
  },
  computed: {
    selectedTariff () {
      if (this.tariff) {
        return this.compileTariff(this.tariff)
      }
      return null
    }
  },
  methods: {
    compileTariff (tariff) {
      tariff.details = this.createDetails(tariff)
      tariff.info = this.createInfo(tariff)
      tariff.actions = [
        {
          type: 'details',
          text: 'Tarifdetails anzeigen'
        }
      ]

      return tariff
    },
    createDetails (tariff) {
      const flatTexts = []
      if (tariff.phoneFlat === 'all') {
        flatTexts.push(tariff.tariffExtra?.flatTexts?.phone)
      }
      if (tariff.smsFlat === 'all') {
        flatTexts.push(tariff?.tariffExtra?.flatTexts?.sms)
      }
      let volumes = []
      if (tariff.tariffExtra !== undefined && tariff.tariffExtra.volumes instanceof Array) {
        volumes = tariff.tariffExtra.volumes
      }
      const priceDetail = {
        primary: price(tariff.basicFee),
        secondary: tariff.runtime.amount === 0 ? null : '/' + tariff.runtime.amount + ' ' + durationUnit(tariff.runtime.unit.toUpperCase(), tariff.runtime.amount)
      }
      return [...flatTexts, ...volumes, priceDetail]
    },
    createInfo (tariff) {
      return {
        name: tariff.name,
        prepend: 'Mein Tarif'
      }
    }
  },
  mixins: [
    slotProxy()
  ]
}
</script>
